"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var components_1 = require("@athena-portal/components");
var SupportPortalTemplates_1 = require("../../SupportPortalTemplates");
var LookupValue_1 = require("../../helpers/LookupValue");
var Tree_1 = require("../../components/Tree");
var React = require("react");
var ConvictionsTree = /** @class */ (function (_super) {
    __extends(ConvictionsTree, _super);
    function ConvictionsTree() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.supportPortalTemplates = new SupportPortalTemplates_1.SupportPortalTemplates;
        return _this;
    }
    ConvictionsTree.prototype.render = function () {
        var personConvictions = [];
        var convictionNumber = 1;
        for (var _i = 0, _a = this.props.convictions; _i < _a.length; _i++) {
            var conviction = _a[_i];
            personConvictions.push((0, jsx_runtime_1.jsx)(Tree_1.Tree, { label: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)("span", { className: "muli-bold-16", children: [this.props.product === "PropositionWolfMotorInsurance" ?
                                    (0, jsx_runtime_1.jsx)(LookupValue_1.LookupValue, { type: "wolfConvictionOffenceCodes", id: conviction.convictionCode }) :
                                    (0, jsx_runtime_1.jsx)(LookupValue_1.LookupValue, { type: "convictionOffenceCodes", id: conviction.convictionCode }), conviction.convictionResultedInABan ? "(banned), " : "(not banned), "] }), this.supportPortalTemplates.convertDate(conviction.convictionDate, "DD/MM/YYYY")] }) }, "conviction" + convictionNumber));
            convictionNumber++;
        }
        return ((0, jsx_runtime_1.jsx)(Tree_1.Tree, { label: "Convictions", children: personConvictions }));
    };
    ConvictionsTree = __decorate([
        components_1.authorize
    ], ConvictionsTree);
    return ConvictionsTree;
}(React.Component));
exports.default = ConvictionsTree;
//# sourceMappingURL=ConvictionsTree.js.map